<template>
  <div class="batch-preview-notice" role="note">
    <i class="el-icon-info" aria-hidden="true" />
    <span>{{ notice }}</span>
  </div>
</template>

<script>
import { batchPreviewNotice } from './index.vue'

export default {
  name: 'DoudianBatchPreviewNotice',
  data: () => ({ notice: batchPreviewNotice }),
}
</script>

<style scoped>
.batch-preview-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #dce8f8;
  background: #f0f6ff;
  color: #527098;
  font-size: 12px;
  line-height: 20px;
}
.batch-preview-notice i {
  margin-top: 3px;
  color: #1677ff;
  font-size: 14px;
}
.batch-preview-notice span {
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
